/*
  "Request a live video" on the product page (snippets/live-video-request.liquid).
  - On variant change the content is taken from the section HTML already fetched by product-info.js,
    so the stock check and the prefilled message stay on the server.
  - A personal LINE link cannot prefill a message: the message is copied to the clipboard before LINE opens.
*/
if (!customElements.get('live-video-request')) {
  customElements.define(
    'live-video-request',
    class LiveVideoRequest extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) =>
            this.onVariantChange(event.data)
          );
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.variantChangeUnsubscriber?.();
      }

      onVariantChange({ sectionId, html }) {
        if (sectionId !== this.dataset.sectionId) return;
        const source = html.getElementById(this.id);
        this.innerHTML = source ? source.innerHTML : '';
        this.hidden = !source || source.hasAttribute('hidden');
      }

      onClick(event) {
        const link = event.target.closest('a[data-copy-message]');
        if (!link) return;

        let message = '';
        try {
          message = JSON.parse(this.querySelector('[data-live-video-message]')?.textContent || '""');
        } catch (error) {
          return;
        }
        if (!message || !navigator.clipboard?.writeText) return;

        navigator.clipboard
          .writeText(message)
          .then(() => {
            const note = this.querySelector('.live-video-request__copied');
            if (note) note.hidden = false;
          })
          .catch(() => {});
      }
    }
  );
}
